import { PISANO_THEME } from '@vision/theme';
import { PlannerBoardColor as PlannerBoardColorEnum } from '../enums';

export const PlannerBoardColor: Record<PlannerBoardColorEnum, { bg: string; fg: string }> = {
  blue: {
    bg: PISANO_THEME.colors.blue[5],
    fg: PISANO_THEME.colors.blue[3],
  },
  red: {
    bg: PISANO_THEME.colors.red[4],
    fg: PISANO_THEME.colors.red[8],
  },
  yellow: {
    bg: PISANO_THEME.colors.yellow[4],
    fg: PISANO_THEME.colors.orange[4],
  },
  green: {
    bg: PISANO_THEME.colors.green[5],
    fg: PISANO_THEME.colors.green[7],
  },
  teal: {
    bg: PISANO_THEME.colors.teal[5],
    fg: PISANO_THEME.colors.teal[8],
  },
  kindness: {
    bg: PISANO_THEME.colors.kindness[5],
    fg: PISANO_THEME.colors.kindness[3],
  },
  purple: {
    bg: PISANO_THEME.colors.purple[4],
    fg: PISANO_THEME.colors.purple[2],
  },
  gray: {
    bg: PISANO_THEME.colors.gray[5],
    fg: PISANO_THEME.colors.gray[1],
  },
  black: {
    bg: PISANO_THEME.colors.dark[5],
    fg: PISANO_THEME.colors.dark[2],
  },
};
